export const globalVariables = {
  policyPrefix :"V1_",
  b2cTenantName: "alt360plus",
  b2cTenantId: "aeac1a48-9581-4987-bf91-b955568658a6", 
  b2cClientId: "91ff64e8-13c8-483a-9ec4-7e075e26f879",
  alt360AQOrigin: "https://alt360plusqa.alt360.com/",
  alt360APIUrl: "https://apialt360plusdev-gucafsfudngfe4cf.eastus2-01.azurewebsites.net",
  microsoftTokensURL: "https://graph.microsoft.com",
  baseAPIUrl: 'https://alt360lucradev.azurewebsites.net',
  palintrAPIUrl: 'https://api.palintra.com',
  // palintrAPIUrl: 'http://localhost:8080',
}